import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";
//import { ReactComponent as DedicatedWarehouseSVG } from "../../../../../assets/icons/warehouse-dedicated.svg";
import Icon from "../../../../../components/icon";
import { ReactComponent as ThickSVG } from "../../../../../assets/icons/thick.svg";
import React from "react";

export type PropertySummaryItem = {
  paleteName: string;
  paleteSize_MMxMMxMM: string;
  paleteWight_Kg: string;
  order: {
    number: string;
    area: string;
    weight: string;
  };
};

interface SummaryProps {
  data: PropertySummaryItem[];
}

export const Quantum = (props: SummaryProps) => {
  return (
    <>
      {props.data.map((property) => (
        <SinglePropertySummaryWraper key={property.paleteName}>
          <DefinitionWraper>
            <SummaryItemName>
              <Icon height="20px" width="20px" noPadding icon={<ThickSVG />} />
              <Title>{property.paleteName}</Title>
            </SummaryItemName>
            <SummaryItemValue>
              <Size>{property.paleteSize_MMxMMxMM}</Size>
              <Weigh>{property.paleteWight_Kg}</Weigh>
            </SummaryItemValue>
          </DefinitionWraper>
          <SummaryWraper>
            <SummaryNumber>Ilość: {property.order.number} szt.</SummaryNumber>
            <SummaryArea>
              Łącznie: {Number(property.order.area).toFixed(2)} m<sup>2</sup>
            </SummaryArea>
            <SummaryWeight>
              Waga: {(Number(property.order.weight) / 1000).toFixed(2)} t
            </SummaryWeight>
          </SummaryWraper>
        </SinglePropertySummaryWraper>
      ))}
    </>
  );
};
const SinglePropertySummaryWraper = styled.div``;
const DefinitionWraper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  @media (max-width: 450px) {
    flex-direction: column;
  }
`;
const SummaryItemName = styled.div`
  display: flex;
  flex-direction: row;
  width: 30%;
  @media (max-width: 450px) {
    width: 100%;
    padding-bottom: 10px;
  }
`;
const Title = styled.div`
  padding-left: 12px;
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.normal};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.gray01_secondaryText};
`;
const SummaryItemValue = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 70%;
  @media (max-width: 450px) {
    width: 100%;
    flex-direction: column;
  }
`;
const Size = styled.div`
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.small};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.black_primaryText};
`;
const Weigh = styled.div`
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.small};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.black_primaryText};
`;
const SummaryWraper = styled.div`
  border: 1px solid #0100c6;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 32px;
  margin-top: 24px;
  margin-bottom: 32px;

  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.small};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.blue01_active};

  @media (max-width: 450px) {
    flex-direction: column;
    margin-left: 0px;
    margin-top: 10px;
    margin-bottom: 15px;
  }
`;
const SummaryNumber = styled.div`
  @media (max-width: 450px) {
    margin: auto auto;
  }
`;
const SummaryArea = styled.div`
  @media (max-width: 450px) {
    margin: auto auto;
  }
  margin-bottom: 5px;
`;
const SummaryWeight = styled.div`
  @media (max-width: 450px) {
    margin: auto auto;
  }
`;
